var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div'),_c('a-layout-content',{staticStyle:{"padding":"0 50px"}},[_c('div',{style:({ background: '#fff', padding: '24px', minHeight: '280px' })},[_c('router-view')],1)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }